import { combineReducers } from "redux";

import a5Reducer from "./a5Reducers";
import alertReducer from "./alertReducers";
import authReducer from "./authReducer";
import calendarReducer from "./calendarReducer";
import configsReducer from "./configsReducer";
import cookieAuthPilotReducer from "./cookieAuthPilotReducer";
import { crisisRiskReducer } from "./reportReducers";
import dynamicRouteConfigReducer from "./dynamicRouteConfigReducer";
import exceptionReportingReducer from "./exceptionReportReducers";
import featureFlagReducer from "./featureFlagReducer";
import { insuranceReducer } from "./insuranceReducers";
import loaderReducer from "./loaderReducer";
import { patientCardInfoReducer } from "./patientCardInfoReducers";
import patientReducer from "./patientReducers";
import { paymentProcessorReducer } from "./paymentProcessorReducers";
import providerReducer from "./providerReducers";
import { toasterReducer } from "./toasterReducers";

export default combineReducers({
  a5Screening: a5Reducer,
  alert: alertReducer,
  auth: authReducer,
  calendar: calendarReducer,
  configs: configsReducer,
  cookieAuthPilot: cookieAuthPilotReducer,
  dynamicRouteConfig: dynamicRouteConfigReducer,
  exceptionReport: exceptionReportingReducer,
  flags: featureFlagReducer,
  insurance: insuranceReducer,
  loader: loaderReducer,
  patient: patientReducer,
  patientCardInfo: patientCardInfoReducer,
  paymentProcessor: paymentProcessorReducer,
  provider: providerReducer,
  reports: {
    crisisRisk: crisisRiskReducer,
  },
  toaster: toasterReducer,
});
